export const generateToken = () => Math.random().toString(36);
